export default {
  title: 'Engineering',
  sections: {
    fields_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Kompetenz</div> in Bau, Geomatik und Planung',
            text2: 'Schweizweites Engineering-Netzwerk: <br/> Lokale Expertise mit internationaler Reichweite',
            image: '/seu/latest-assets/seu_25.jpg',
          }
        },
      }
    },
    fields_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Engineering'
          }
        }
      }
    },
    fields_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_30.jpg',
          }
        }
      }
    },
    fields_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<span class="text-highlight">Führende Engineering-Gruppe </span> in der Schweiz'
          }
        },
        field_two: {
          value: {
            text: 'Die SEU vereint visionäres Denken mit höchsten Ansprüchen und eigener Offshore-Produktion.'
          }
        },
        field_three: {
          value: {
           text: 'Als führender Engineering-Partner verfügen wir über umfassende Ressourcen in der Schweiz und unterstützen diese gezielt mit internationalen Produktionsstätten. Diese stehen unseren Partnerunternehmen zur Verfügung – für noch mehr Wettbewerbsfähigkeit in den Geschäftsfeldern Bau, Geomatik und Planung.'
          }
        },
      }
    },
    fields_feature_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                image: '/seu/icon-mechanic.svg',
                mainTitle: 'Bau',
                subTitle: 'Qualität in der Tiefe und Kompetenz mit Weitsicht',
                description: `Wir bringen die Besten der Schweizer Ingenieur-Branche zusammen, um gemeinsam noch effizienter und profitabler zu agieren.`,
                buttonLabel: 'Unsere Stärken sind',
                items: `
                <ul> <li> Bauengineering im Hochbau und Tiefbau</li>
<li>Projektmanagement und Projektentwicklung </li>
<li>Bauleitung </li>
<li>Bauherrenunterstützung </li>
<li>BIM (Building Information Management) </li>
<li>Gemeindeingenieurwesen </li></ul>
                `,
              },
              {
                image: '/seu/icon-geomatic.svg',
                mainTitle: 'Geomatik',
                subTitle: 'Bis ins kleinste Detail unerschütterlich präzise',
                description: 'Wir sind Expertinnen, Weitdenker, Fachspezialistinnen und Innovationstreiber in allen Bereichen der Geomatik.',
                buttonLabel: 'Unsere Stärken sind',
                items: `
             <ul> <li> Gebäudeaufnahmen (Architekturvermessung, Gebäudevermessung)  </li>
<li>   3D-Modelle (BIM-Modelle, digitale Zwillinge, as-built-Modelle)</li>
<li>   Amtliche Vermessung</li>
<li>   Geoinformationssysteme</li>
<li>   Bauvermessung, Ingenieurvermessung</li>
<li>   Überwachungsmessung (geodätisch, geotechnisch, Geomonitoring)</li>
<li>   Erschütterungsmessung</li>
<li>   Beweissicherung</li>
<li>   Tunnelvermessung</li> </ul>
                `
              },
              {
                image: '/seu/icon-planning.svg',
                mainTitle: 'Planung',
                subTitle: 'Lebensräume gestalten und Versorgungsströme lenken',
                description: 'Wir wollen gemeinsam neue Lebensräume entwickeln, erschliessen und bebauen. Wir verschreiben uns der Nachhaltigkeit im Denken und der Präzision in der Umsetzung.',
                buttonLabel: 'Unsere Stärken sind',
                items: `
<ul> <li> Raumentwicklung (Richtplanung, Nutzungsplanung, Arealplanung, Quartierplanung) </li>
<li>Verkehrsplanung (Verkehrslenkung, Verkehrsberuhigung, Verkehrssicherheit, Lärmschutz) </li>
<li>Umweltplanung (Umweltverträglichkeit, Umweltbaubegleitung) </li>
<li>Energie- und Nachhaltigkeit </li> </ul>
                  `
              },

            ]
          }
        },

      }
    }
  }
}
